<template>
    <div class="container">
        <div class="sala">
                <button title="Close window" @click="closeWindow"> <i title="close window" style="transform: rotate(45deg);" class="fas fa-plus"></i></button>
                <h2> أذكار الصلاة </h2>

                <div>
                    <strong> قراءة آية الكرسى </strong>
                    <p>
                        اللّهُ لاَ إِلَـهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي
                        السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا
                        بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلاَّ بِمَا شَاء
                        وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيمُ
                    </p>
                    <span title="null"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span title="null"></span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <strong> قراءة سورة الإخلاص </strong>
                    <p>
                        قُلْ هُوَ ٱللَّهُ أَحَدٌ، ٱللَّهُ ٱلصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُن لَّهُۥ كُفُوًا
                        أَحَدٌۢ
                    </p>
                    <span> ثلاث مرات بعد صلاتي الفجر والمغرب. ومرة بعد الصلوات الأخرى </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span title="null"></span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <strong> قراءة سورة الفلق </strong>
                    <p>
                        قُلْ أَعُوذُ بِرَبِّ ٱلْفَلَقِ، مِن شَرِّ مَا خَلَقَ، وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ، وَمِن شَرِّ
                        ٱلنَّفَّٰثَٰتِ فِى ٱلْعُقَدِ، وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ
                    </p>
                    <span> ثلاث مرات بعد صلاتي الفجر والمغرب. ومرة بعد الصلوات الأخرى </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span title="null"></span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <strong> قراءة سورة الناس </strong>
                    <p>
                        قُلْ أَعُوذُ بِرَبِّ ٱلنَّاسِ، مَلِكِ ٱلنَّاسِ، إِلَٰهِ ٱلنَّاسِ، مِن شَرِّ ٱلْوَسْوَاسِ
                        ٱلْخَنَّاسِ، ٱلَّذِى يُوَسْوِسُ فِى صُدُورِ ٱلنَّاسِ، مِنَ ٱلْجِنَّةِ وَٱلنَّاسِ
                    </p>
                    <span> ثلاث مرات بعد صلاتي الفجر والمغرب. ومرة بعد الصلوات الأخرى </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span title="null"></span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p> لا إلهَ إلاّ اللّهُ وحْـدَهُ لا شريكَ لهُ، لهُ المُلكُ ولهُ الحَمْد، يُحيـي وَيُمـيتُ وهُوَ على كُلّ
                        شيءٍ قدير </p>
                    <span> عَشْر مَرّات بَعْدَ المَغْرِب وَالصّـبْح </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span title="null"></span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        للّهُـمَّ إِنِّـي أَسْأَلُـكَ عِلْمـاً نافِعـاً وَرِزْقـاً طَيِّـباً ، وَعَمَـلاً مُتَقَـبَّلاً
                    </p>
                    <span> بَعْد السّلامِ من صَلاةِ الفَجْر </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span title="null"></span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        اللَّهُمَّ أَجِرْنِي مِنْ النَّار
                    </p>
                    <span> بعد صلاة الصبح والمغرب </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span title="null"></span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>
                
            </div>
            </div>
</template>


<script>
import { copyShare } from "./sharing"
import { teleShare } from "./sharing"
import { twitterShare } from "./sharing"
import { waShare } from "./sharing"
export default {

    mounted() {
        copyShare();
        teleShare();
        twitterShare();
        waShare();
    },
    methods: {
        closeWindow() {
            this.$emit("closeSala", false);
        },
        
    }
}
</script>